export const FETCH_EMPLOYE_REQUEST = 'FETCH_EMPLOYE_REQUEST';
export const FETCH_EMPLOYE_SUCCESS = 'FETCH_EMPLOYE_SUCCESS';
export const FETCH_EMPLOYE_FAILURE = 'FETCH_EMPLOYE_FAILURE';
